import { OptimaxService } from '../../mailing/shared/services/optimax.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'emailToLink',
    pure: false
})
export class EmailToLinkPipe implements PipeTransform {

    constructor(private mailingService: OptimaxService) {
    }

    transform(value: any) {
        if (value && this.isValidEmail(value)) {
            const url = localStorage.getItem('optimaxComposeUrl');
            // Si l'utilisateur est connecté, sinon composeUrl = null
            if (url) {
                return '<a href="' + url + '&to=' + value + '" target="_blank" class="text-secondary optimax-link-mailto-enabled"><i class="fa fa-at mr-2"></i><span> ' + value + ' </span></a>';
            }
        }
        return '<span class="optimax-link-mailto-disabled"><i class="fa fa-at mr-2"></i><span> ' + value + ' </span></span>';
    }

    isValidEmail(email: string) {
        const regex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        return email.match(regex) !== null;
    }
}
